import React, { useState } from "react";
import { FaTimes } from "react-icons/fa";
import DonateForm from "./DonateForm"; // Import DonateForm

const TermsAndConditionsPopup = ({ onClose, projectData }) => {
  const [selectedOption, setSelectedOption] = useState("Local Project Pool"); // Default selection
  const [showDonateForm, setShowDonateForm] = useState(false); // Toggle DonateForm

  // Skip this component for charity projects
  if (projectData.type === "charity") {
    return null;
  }

  const handleAgreeAndContinue = () => {
    setShowDonateForm(true); // Show DonateForm with selected option
  };

  return (
    <div
      style={{
        position: "fixed",
        top: "0",
        left: "0",
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1000,
      }}
    >
      {!showDonateForm ? (
        <div
          style={{
            width: "450px",
            backgroundColor: "#fff",
            padding: "20px",
            borderRadius: "10px",
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
            position: "relative",
            maxHeight: "90vh",
            overflowY: "auto",
          }}
        >
          {/* Close button */}
          <FaTimes
            onClick={onClose}
            style={{
              position: "absolute",
              right: "20px",
              top: "20px",
              cursor: "pointer",
              fontSize: "20px",
              color: "#555",
            }}
          />

          {/* Heading */}
          <h1
            style={{
              fontSize: "24px",
              fontWeight: "bold",
              textAlign: "center",
              marginBottom: "20px",
              color: "#000",
            }}
          >
            Donation Box
          </h1>

          {/* Terms & Conditions Summary */}
          <div
            style={{
              fontSize: "14px",
              color: "#555",
              lineHeight: "1.6",
              marginBottom: "20px",
              textAlign: "justify",
            }}
          >
            <h4>Rules for Incomplete Project Funding
            </h4>
            <ul style={{ paddingLeft: "20px" }}>
              <li>
                <strong>Local Projects Pool:</strong> If the selected project does not meet its
                funding goal, the contribution will be redirected to the Local Projects Pool, which
                funds the top community-selected projects.
              </li>
              <li>
                <strong>Refund Option:</strong> Donors who select this option at the time of donation
                will receive a refund if the project does not meet its funding goal. Refunds are
                subject to a 3.9% + $0.30 transaction fee to cover processing costs.
              </li>
            </ul>
          </div>

          {/* Dropdown Selection */}
          <div style={{ marginBottom: "20px" }}>
            <label
              htmlFor="donationPurpose"
              style={{
                fontSize: "14px",
                fontWeight: "bold",
                color: "#555",
                display: "block",
                marginBottom: "5px",
              }}
            >
                Please Select:
            </label>
            <select
              id="donationPurpose"
              value={selectedOption}
              onChange={(e) => setSelectedOption(e.target.value)}
              style={{
                width: "100%",
                padding: "10px",
                fontSize: "14px",
                borderRadius: "5px",
                border: "1px solid #ccc",
                color: "#333",
                backgroundColor: "#fff",
                cursor: "pointer",
              }}
            >
              <option value="Local Project Pool">Local Project Pool</option>
              <option value="Refund">Refund</option>
            </select>
          </div>

          {/* Agree & Continue Button */}
          <div style={{ textAlign: "center" }}>
            <button
              onClick={handleAgreeAndContinue}
              style={{
                width: "100%",
                padding: "10px",
                fontSize: "16px",
                fontWeight: "bold",
                color: "#fff",
                backgroundColor: "#007bff",
                border: "none",
                borderRadius: "5px",
                cursor: "pointer",
                transition: "background-color 0.3s ease",
              }}
              onMouseOver={(e) => (e.target.style.backgroundColor = "#0056b3")}
              onMouseOut={(e) => (e.target.style.backgroundColor = "#007bff")}
            >
              Agree & Continue
            </button>
          </div>
        </div>
      ) : (
        <DonateForm onClose={onClose} selectedPurpose={selectedOption} /> // Pass selected option to DonateForm
      )}
    </div>
  );
};

export default TermsAndConditionsPopup;
